import { Component, OnInit } from '@angular/core';
import { HomeTitle, HomeSubmsg } from '../../../core/constants/common';


@Component({
  selector: 'school-homeaside',
  templateUrl: './homeaside.component.html',
  styleUrls: ['./homeaside.component.scss']
})
export class HomeasideComponent implements OnInit {
  // titlemsg: string = HomeTitle;
  // shortdescmsg: string = HomeSubmsg;
  constructor() { }

  ngOnInit(): void {
  }

}
